import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { AuthProvider } from './providers/AuthProvider'
import * as Sentry from '@sentry/react'

if ((import.meta as any).env.VITE_SENTRY_DSN) {
  Sentry.init({ dsn: (import.meta as any).env.VITE_SENTRY_DSN, integrations: [], tracesSampleRate: 0.1 })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)
